import { useState } from 'react';

import './video.css';
import { Link } from 'react-router-dom';
import { Button, Modal, Ratio } from 'react-bootstrap';

const VideoPopup = (props) => {
  const [show, setShow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0)


  const setShowButton = (index) => {
    setShow(true)
    setActiveIndex(index)
  }
  const setHide = (index) => {
    setShow(false)
    setActiveIndex(0)
  }
  return (
    <>
      <div className={`video-popup  ${props.theme || ''}`}>
      <Button
          className={`${show ? "video-btn-innactive" : "video-btn scale-110"}`}
          // variant="primary"
          onClick={() => setShowButton(props.index)}
        >
          <i className={`fas fa-play duration-300 ${show ? "scale-[2.5] opacity-0" : "scale-100 opacity-100"}`}></i>
        </Button>
        {(props?.theme === 'video-style-2') === !props.imageHide || (
          <video
            alt='video-image'
            className="img-fluid image-link "
            src={props.videoImage}
          >
          </video>
        )}

        <div className="case-study-info">
        <div
            className="case-study-title"
            
          >
            {props.title}
          </div>
        </div>
      </div>

      <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setHide(props.index)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Ratio aspectRatio="16x9">
          <video width="320" height="240" controls autoPlay>
            <source src={props.videoURL} type="video/mp4" />
          </video>
          </Ratio>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default VideoPopup;
